<template>
  <a-config-provider :locale="locale">
    <App />
  </a-config-provider>
</template>

<script lang="ts">
import ru from "ant-design-vue/lib/locale/ru_RU"
import uk from "ant-design-vue/lib/locale/uk_UA"
import { mapState } from "vuex"

import App from "@/App.vue"

export default {
  name: "LocaleProvider",

  components: {
    App
  },

  data() {
    return {
      ru,
      uk
    }
  },

  computed: {
    ...mapState("common", {
      currentLocale: (state: any): string => state.currentLocale
    }),

    locale() {
      return this[this.currentLocale]
    }
  }
}
</script>
